import authRequest from "../utils/authRequest";


export const getAllWhiteList = (
    client_id?:string,
      gateway_id?:string,
    // page: number,
    // pageSize: number = 50,
    // searchTexts?: any
): Promise<any> => {
    return new Promise((resolve, reject) => {
        authRequest({
            // url: `/api/v1/whitelist?page=${page}&per_page=${pageSize}&searchTexts=${searchTexts ? searchTexts : ""}`,
            url: `/api/v1/whitelist/${client_id}/${gateway_id}`,
            method: "get",
            // params: params
        })
            .then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const createWhiteListClient = (data: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        authRequest({
            url: "/api/v1/whitelist",
            method: "post",
            data,
        })
            .then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const deleteWhiteListRecord = (id: string): Promise<any> => {
    return new Promise((resolve, reject) => {
        authRequest({
            url: "/api/v1/whitelist/" + id,
            method: "delete",
        })
            .then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const getWhitwListRecordById = (id: string): Promise<any> => {
    return new Promise((resolve, reject) => {
        authRequest({
            url: "/api/v1/get_whitelist/" + id,
            method: "get",
        })
            .then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const getWhitwListHistoryById = (id: string): Promise<any> => {
    return new Promise((resolve, reject) => {
        authRequest({
            url: "/api/v1/whitelisthistory/" + id,
            method: "get",
        })
            .then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};


export const updateWhiteListRecord = (data: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        authRequest({
            url: "/api/v1/whitelist/" + data?.id,
            method: "put",
            data,
        })
            .then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};





